import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import './helpers/initFA';
import { store } from './Redux/Store/store';
import { Provider } from 'react-redux';
import * as $ from "jquery";


const DEFAULT_TITLE = "MergeCall – Smart Calling & Communication Platform";
const STORAGE_KEY = "lastValidTitle";
const INVALIDS = new Set(["", "undefined", "null", "NaN", "[object Object]"]);

function ensureTitleEl() {
  let t = document.querySelector("title");
  if (!t) {
    t = document.createElement("title");
    document.head.appendChild(t);
  }
  return t;
}

function getSavedTitle() {
  return localStorage.getItem(STORAGE_KEY) || DEFAULT_TITLE;
}

function isInvalidTitle(val) {
  return !val || INVALIDS.has(String(val).trim());
}

function setSafeTitle(next) {
  const safe = isInvalidTitle(next) ? getSavedTitle() : String(next);
  document.title = safe;
  // only save if valid (avoid persisting junk)
  if (!isInvalidTitle(safe)) localStorage.setItem(STORAGE_KEY, safe);
}

function syncNow() {
  const cur = String(document.title || "").trim();
  if (isInvalidTitle(cur)) {
    setSafeTitle(getSavedTitle());
  } else {
    localStorage.setItem(STORAGE_KEY, cur);
  }
}

// 1) Initialize early
ensureTitleEl();
if (isInvalidTitle(document.title)) {
  setSafeTitle(getSavedTitle());
}

// 2) Restore on common lifecycle hooks
window.addEventListener("focus", () => {
  // run after anything else that might set an invalid title on focus
  setTimeout(syncNow, 0);
});
document.addEventListener("visibilitychange", syncNow);
window.addEventListener("pageshow", syncNow); // bfcache restore
// Keep other windows in sync
window.addEventListener("storage", (e) => {
  if (e.key === STORAGE_KEY) syncNow();
});

// 3) Observe ALL changes to <title> and <head>
const titleEl = ensureTitleEl();
const observer = new MutationObserver(() => syncNow());
// observe text node changes inside <title>
observer.observe(titleEl, { childList: true, subtree: true, characterData: true });
// some libs replace the <title> node; also watch head subtree
const headObserver = new MutationObserver(() => {
  // if <title> was replaced, reattach the observer
  const latestTitle = document.querySelector("title") || ensureTitleEl();
  if (latestTitle !== titleEl) {
    observer.disconnect();
    observer.observe(latestTitle, { childList: true, subtree: true, characterData: true });
  }
  syncNow();
});
headObserver.observe(document.head, { childList: true, subtree: true });

ReactDOM.render(
  <Provider store={store}> 
   <Main>
    <App />
  </Main>
</Provider>,
  document.getElementById('main')
);
